/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind =
  {
    Approve: "approve",
    Burn: "burn",
    Mint: "mint",
    Transfer: "transfer",
  } as const;
export type ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind =
  ClosedEnum<
    typeof ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind
  >;

export const ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy =
  {
    Index: "index",
    MinusIndex: "-index",
    Amount: "amount",
    MinusAmount: "-amount",
    Timestamp: "timestamp",
    MinusTimestamp: "-timestamp",
    Kind: "kind",
    MinusKind: "-kind",
  } as const;
export type ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy =
  ClosedEnum<
    typeof ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy
  >;

export type ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest =
  {
    ledgerCanisterId: string;
    /**
     * Only match values after this id
     */
    after?: Array<string> | undefined;
    /**
     * Only match values before this id
     */
    before?: Array<string> | undefined;
    limit?: number | undefined;
    includeKind?:
      | Array<
        ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind
      >
      | undefined;
    start?: number | undefined;
    end?: number | undefined;
    sortBy?:
      | ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy
      | undefined;
  };

/** @internal */
export const ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind$inboundSchema:
  z.ZodNativeEnum<
    typeof ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind
  > = z.nativeEnum(
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind,
  );

/** @internal */
export const ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind$outboundSchema:
  z.ZodNativeEnum<
    typeof ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind
  > =
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind$ {
  /** @deprecated use `ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind$inboundSchema` instead. */
  export const inboundSchema =
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind$inboundSchema;
  /** @deprecated use `ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind$outboundSchema` instead. */
  export const outboundSchema =
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind$outboundSchema;
}

/** @internal */
export const ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy$inboundSchema:
  z.ZodNativeEnum<
    typeof ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy
  > = z.nativeEnum(
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy,
  );

/** @internal */
export const ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy$outboundSchema:
  z.ZodNativeEnum<
    typeof ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy
  > =
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy$ {
  /** @deprecated use `ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy$inboundSchema` instead. */
  export const inboundSchema =
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy$inboundSchema;
  /** @deprecated use `ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy$outboundSchema` instead. */
  export const outboundSchema =
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy$outboundSchema;
}

/** @internal */
export const ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$inboundSchema:
  z.ZodType<
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    after: z.array(z.string()).optional(),
    before: z.array(z.string()).optional(),
    limit: z.number().int().default(20),
    include_kind: z.array(
      ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind$inboundSchema,
    ).optional(),
    start: z.number().optional(),
    end: z.number().optional(),
    sort_by:
      ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy$inboundSchema
        .default("-index"),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
      "include_kind": "includeKind",
      "sort_by": "sortBy",
    });
  });

/** @internal */
export type ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$Outbound =
  {
    ledger_canister_id: string;
    after?: Array<string> | undefined;
    before?: Array<string> | undefined;
    limit: number;
    include_kind?: Array<string> | undefined;
    start?: number | undefined;
    end?: number | undefined;
    sort_by: string;
  };

/** @internal */
export const ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$outboundSchema:
  z.ZodType<
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$Outbound,
    z.ZodTypeDef,
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    after: z.array(z.string()).optional(),
    before: z.array(z.string()).optional(),
    limit: z.number().int().default(20),
    includeKind: z.array(
      ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetIncludeKind$outboundSchema,
    ).optional(),
    start: z.number().optional(),
    end: z.number().optional(),
    sortBy:
      ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetSortBy$outboundSchema
        .default("-index"),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
      includeKind: "include_kind",
      sortBy: "sort_by",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$ {
  /** @deprecated use `ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$inboundSchema;
  /** @deprecated use `ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$outboundSchema;
  /** @deprecated use `ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$Outbound` instead. */
  export type Outbound =
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$Outbound;
}

export function listTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequestToJSON(
  listTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest:
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest,
): string {
  return JSON.stringify(
    ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$outboundSchema
      .parse(
        listTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest,
      ),
  );
}

export function listTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListTransactionsApiV2LedgersLedgerCanisterIdTransactionsGetRequest' from JSON`,
  );
}
